export default {
  name: 'purchaseSummary',
  bindings: {
    purchase: '<'
  },
  controller: ['$state',
    class {
      constructor($state) {
        this.visible = false;
        this.$state = $state;
      }

      hacerPedido() {
        this.visibleModal = false;
        this.$state.go('purchaseConfirm');
      }

      isPurchaseConfirm() {
        return this.$state.current.name === 'purchaseConfirm';
      }


      toggleSummaryModal() {
        this.visibleModal = true;
      }
    }
  ],
  templateUrl: '/template/render/?tpl=/oferta-navidad/purchaseSummary.php'
};


// WEBPACK FOOTER //
// ./oferta-navidad/purchaseSummaryComponent.js